import { useRef, useState } from "react";
import { sidenavActions } from "../../../context/actions/sidenavActions";
import useStore from "../../../context/useStore";
import LeadCancelSelector from "../../pages/SimplifiedFormListPage/LeadStatus/LeadCancelSelector";
import MenuFlottant from "../MenuFlottant/MenuFlottant";

// Statut du lead en pastille lisible, avec son menu de changement. Un abandon
// demande toujours son motif, dans le volet latéral, comme avant (StatusSelector).
const StatutLead = ({ lead, onUpdateStatus, portee = "carte" }) => {
  const [state, dispatch] = useStore();
  const sideActions = sidenavActions(state, dispatch);
  const { LEAD_STATUS } = state.constants.items;
  const [ouvert, setOuvert] = useState(false);
  const refBouton = useRef(null);
  const statusRef = LEAD_STATUS.find((s) => s.id === lead.status);

  if (!statusRef) return null;

  const choisir = (status) => {
    setOuvert(false);
    if (status === lead.status) return;
    if (status === "CANCEL") {
      sideActions.updateSidenav({
        isOpen: true,
        content: (
          <LeadCancelSelector
            onValidate={(reason) => {
              sideActions.updateSidenav({ isOpen: false, content: null });
              onUpdateStatus(status, reason);
            }}
          />
        ),
      });
      return;
    }
    onUpdateStatus(status);
  };

  return (
    <div className="la-ancre">
      <button
        ref={refBouton}
        type="button"
        className={`la-statut la-ton-${statusRef.color}`}
        aria-haspopup="menu"
        aria-expanded={ouvert}
        aria-label={`Statut : ${statusRef.name}. Changer le statut`}
        onClick={() => setOuvert((valeur) => !valeur)}
      >
        <i className={`fa fa-${statusRef.icon}`} aria-hidden="true" />
        <span className="la-statut__nom">{statusRef.name}</span>
        <i className="fa fa-chevron-down la-statut__chevron" aria-hidden="true" />
      </button>
      <MenuFlottant
        ouvert={ouvert}
        onFermer={() => setOuvert(false)}
        refBouton={refBouton}
        titre="Statut du lead"
        aligne={portee === "panneau" ? "gauche" : "droite"}
      >
        {LEAD_STATUS.map((s) => (
          <button
            key={s.id}
            type="button"
            role="menuitemradio"
            aria-checked={s.id === lead.status}
            className={`la-menu__item la-ton-${s.color}`}
            onClick={() => choisir(s.id)}
          >
            <i className={`fa fa-${s.icon} la-menu__icone la-menu__icone--statut`} aria-hidden="true" />
            {s.name}
            {s.id === lead.status && <i className="fa fa-check la-menu__coche" aria-hidden="true" />}
          </button>
        ))}
      </MenuFlottant>
    </div>
  );
};

export default StatutLead;
